<form class="login-formulario" [formGroup]="authForm" (ngSubmit)="onSubmit()">
  <img
    class="login-marca"
    ngSrc="assets/images/logo-carta-servicos.png"
    width="180"
    height="48"
    alt="Carta de Serviços"
  />
 
  <p class="login-titulo" id="login-titulo" role="heading" [attr.aria-level]="nivelTitulo()">
    Bem-vindo!
  </p>
  <p class="login-subtitulo">Acesse sua conta para continuar</p>

  <label class="login-rotulo" for="usuario">CPF / CNPJ</label>
  <div class="login-campo">
    <i-lucide class="login-campo-icone" name="id-card" size="18" aria-hidden="true"></i-lucide>
    <input
      id="usuario"
      class="login-campo-input"
      type="text"
      formControlName="usuario"
      inputmode="numeric"
      [mask]="mascaraDocumento"
      autocomplete="username"
      placeholder="Digite seu CPF ou CNPJ"
    />
  </div>
  @if (f.usuario.touched) {
    @if (f.usuario.hasError('required')) {
      <p class="login-erro-campo">Usuário é obrigatório.</p>
    } @else if (f.usuario.hasError('usuarioInvalido')) {
      <p class="login-erro-campo">Informe um CPF ou CNPJ válido.</p>
    }
  }

  <label class="login-rotulo" for="senha">Senha</label>
  <div class="login-campo">
    <i-lucide class="login-campo-icone" name="shield" size="18" aria-hidden="true"></i-lucide>
    <input
      id="senha"
      class="login-campo-input"
      [type]="senhaVisivel() ? 'text' : 'password'"
      formControlName="senha"
      autocomplete="current-password"
      placeholder="Digite sua senha"
    />
    <button
      type="button"
      class="login-campo-olho"
      [attr.aria-label]="senhaVisivel() ? 'Ocultar senha' : 'Mostrar senha'"
      [attr.aria-pressed]="senhaVisivel()"
      (click)="alternarSenha()"
    >
      <i-lucide [name]="senhaVisivel() ? 'eye-off' : 'eye'" size="18" aria-hidden="true"></i-lucide>
    </button>
  </div>
  @if (f.senha.touched && f.senha.hasError('required')) {
    <p class="login-erro-campo">Senha é obrigatória.</p>
  }

  @if (loginError()) {
    <p class="login-erro" role="alert" aria-live="assertive">{{ loginError() }}</p>
  }

  <button type="submit" class="login-acessar" [disabled]="authForm.invalid || loading()">
    {{ loading() ? 'Conectando...' : 'Acessar' }}
  </button>

  <p class="login-separador"><span>ou</span></p>

  <a class="login-govbr" href="#" (click)="$event.preventDefault()">
    <img class="login-govbr-marca" ngSrc="assets/images/login-gov.svg" width="62" height="18" alt="gov.br" />
    Entrar com sua conta
  </a>

  <p class="login-ajuda">
    <a
      class="login-ajuda-link"
      href="https://sai3.io.org.br/Account/ForgotPassword"
      target="_blank"
      rel="noopener"
    >
      Esqueceu sua senha?
    </a>
  </p>
  <p class="login-ajuda">
    <a class="login-cadastrar" routerLink="/cadastro">Cadastrar</a>
  </p>
</form>
